import { PageHeader, Breadcrumb, Spin, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";

import Page from "_components/Page";
import { Link } from "react-router-dom";
import { dashboardService } from "_services";
import { CurrencyFormatter } from "_helpers/formatters";
function TiepAgingLiability() {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [agingData, setAgingData] = useState([]);

  const getDataForTable = (data) => {
    let records = [];

    records.push({
      duty: "CID",
      ageLt90: data?.ageLt90?.netCidAmount,
      age90To180: data?.age90To180?.netCidAmount,
      age180To270: data?.age180To270?.netCidAmount,
      age270To360: data?.age270To360?.netCidAmount,
      ageGt360: data?.ageGt360?.netCidAmount,
    });

    records.push({
      duty: "EID",
      ageLt90: data?.ageLt90?.netEidAmount,
      age90To180: data?.age90To180?.netEidAmount,
      age180To270: data?.age180To270?.netEidAmount,
      age270To360: data?.age270To360?.netEidAmount,
      ageGt360: data?.ageGt360?.netEidAmount,
    });

    records.push({
      duty: "PAL",
      ageLt90: data?.ageLt90?.netPalAmount ?? 0,
      age90To180: data?.age90To180?.netPalAmount ?? 0,
      age180To270: data?.age180To270?.netPalAmount,
      age270To360: data?.age270To360?.netPalAmount,
      ageGt360: data?.ageGt360?.netPalAmount,
    });

    records.push({
      duty: "SSL",
      ageLt90: data?.ageLt90?.netSslAmount,
      age90To180: data?.age90To180?.netSslAmount,
      age180To270: data?.age180To270?.netSslAmount,
      age270To360: data?.age270To360?.netSslAmount,
      ageGt360: data?.ageGt360?.netSslAmount,
    });

    console.table("records", records);
    return records;
  };

  useEffect(() => {
    setIsLoading(true);

    getAllAgingData();
  }, []);

  const getAgingDataColumns = () => {
    let columns = [];

    columns.push({
      title: "Duty",
      align: "center",
      dataIndex: "duty",
      key: "duty",
      width: "5%",
      render: (text, record) => text,
    });

    columns.push({
      title: "0-3 Months",
      align: "center",
      dataIndex: "ageLt90",
      key: "ageLt90",
      width: "5%",
      render: (text, record) => {
        if (text && text > 0) return CurrencyFormatter(text);
      },
    });

    columns.push({
      title: "3-6 Months",
      align: "center",
      dataIndex: "age90To180",
      key: "age90To180",
      width: "5%",
      render: (text, record) => {
        if (text && text > 0) return CurrencyFormatter(text);
      },
    });

    columns.push({
      title: "6-9 Months",
      align: "center",
      dataIndex: "age180To270",
      key: "age180To270",
      width: "5%",
      render: (text, record) => {
        if (text && text > 0) return CurrencyFormatter(text);
      },
    });

    columns.push({
      title: "9-12 Months",
      align: "center",
      dataIndex: "age270To360",
      key: "age270To360",
      width: "5%",
      render: (text, record) => {
        if (text && text > 0) return CurrencyFormatter(text);
      },
    });

    columns.push({
      title: " ~ > 12 Months",
      align: "center",
      dataIndex: "ageGt360",
      key: "ageGt360",
      width: "5%",
      render: (text, record) => {
        if (text && text > 0) return CurrencyFormatter(text);
      },
    });

    return columns;
  };
  const getAllAgingData = () => {
    setIsLoading(true);
    dashboardService
      .getstockIssuePendingAgingSummary()
      .then((data) => {
        setAgingData(data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error);
      });
  };

  const getAgingSearchData = (values) => {
    if (!values?.bomId) {
      setAgingData([]);
      return;
    }

    let params = `?ageRange=${values?.duration ?? "AGE_LT_90"}&product=${
      values?.bomId
    }`;
    setIsLoading(true);
    dashboardService
      .getstockIssuePendingAgingSummary(params)
      .then((data) => {
        setAgingData(data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error);
      });
  };
  const onSearch = (values) => {
    getAgingSearchData(values);
  };
  const onClear = () => {
    getAllAgingData();
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/reports">Reports</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/reports/Aging-Reports">Pending Credit Aging</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
      >
        <Page error={error}>
          <Spin spinning={isLoading}>
            {agingData && (
              <Table
                bordered
                pagination={false}
                columns={getAgingDataColumns()}
                dataSource={getDataForTable(agingData)}
                size="small"
              ></Table>
            )}
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default TiepAgingLiability;
